import AuthenticationService from '../AuthenticationService';

var inactivityTimerId = void 0;
var logoutConfirmationTimerId = void 0;

export default (function (_ref) {
    var oAuthConfig = _ref.oAuthConfig,
        logoutWarningCallback = _ref.logoutWarningCallback,
        _ref$inactivityInterv = _ref.inactivityIntervalMins,
        inactivityIntervalMins = _ref$inactivityInterv === undefined ? 5 : _ref$inactivityInterv,
        _ref$logoutConfirmati = _ref.logoutConfirmationIntervalMins,
        logoutConfirmationIntervalMins = _ref$logoutConfirmati === undefined ? 1 : _ref$logoutConfirmati;


    var authenticationService = AuthenticationService(oAuthConfig);

    function initializeInActivityTimer() {
        var warningModal = void 0;
        var inactivityInterval = inactivityIntervalMins * 1000 * 60;
        // initial timer to check for inactivity
        inactivityTimerId = window.setTimeout(function () {
            var logoutConfirmationInterval = logoutConfirmationIntervalMins * 1000 * 60;

            // second timer to show warning message for a period of time
            logoutConfirmationTimerId = window.setTimeout(function () {
                warningModal.close();
                authenticationService.logout();
            }, logoutConfirmationInterval);
            warningModal = logoutWarningCallback(resetInactivityTimer);
        }, inactivityInterval);
    }

    function resetInactivityTimer() {
        deactivateTimers();
        initializeInActivityTimer();
    }

    function deactivateTimers() {
        if (inactivityTimerId) {
            window.clearTimeout(inactivityTimerId);
            inactivityTimerId = null;
        }
        if (logoutConfirmationTimerId) {
            window.clearTimeout(logoutConfirmationTimerId);
            logoutConfirmationTimerId = null;
        }
    }

    authenticationService.onLoginStateChange(function (authData) {
        var authtenticatedFlag = authData.isLoggedIn;
        if (authtenticatedFlag) {
            // kick off a timer when user logs in
            resetInactivityTimer();
        } else {
            // if user has logged out then deactive the timers
            deactivateTimers();
        }
    });

    return {
        // this method is called by the transport service, called every time the user makes an XHR call to the backend -
        resetInactivityTimer: resetInactivityTimer
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-js/utils/InactivityTimer.js
// module id = 1340
// module chunks = 0